module.exports = __webpack_public_path__ + "static/media/personal_media_lto.1161ddbc.xlsx";